export * from './IconAwardRibbon';
export { default as IconAwardRibbon } from './IconAwardRibbon';
